import React, { Component } from 'react';
import PT from 'prop-types';
import { Radio } from 'semantic-ui-react';
import camelCase from 'camelcase';
import classNames from 'classnames';
import classes from './filterToggle.css';

export default class FilterToggle extends Component {
  static propTypes = {
    checked: PT.bool.isRequired,
    onChange: PT.func.isRequired,
    valueOff: PT.oneOfType([PT.number, PT.string]).isRequired,
    valueOn: PT.oneOfType([PT.number, PT.string]).isRequired,
    label: PT.string,
    className: PT.string,
    disabled: PT.bool,
  };

  static defaultProps = {
    label: '',
    className: '',
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      checked: props.checked,
    };
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.checked !== this.state.checked) {
      this.setState({ checked: nextProps.checked });
    }
  }

  handleChange = (e, { checked }) => {
    this.setState({ checked });
    this.props.onChange(checked);
  }

  render() {
    const { checked } = this.state;
    const {
      label,
      valueOff,
      valueOn,
      className,
      disabled,
    } = this.props;

    const valueOffLabel = classNames({
      [classes.dim]: checked,
      [classes.active]: !checked,
      [classes.leftPosition]: true,
    });

    const valueOnLabel = classNames({
      [classes.dim]: !checked,
      [classes.active]: checked,
      [classes.rightPosition]: true,
    });

    return (
      <div className={`${classes.toggleContainer} ${className}`}>
        <label className={classes.label} htmlFor={camelCase(label)}>{label}</label>
        <div className={classes.toggle}>
          <span className={valueOffLabel}>{String(valueOff)}</span>
          <Radio
            toggle
            id={camelCase(label)}
            checked={checked}
            onChange={this.handleChange}
            className={classes.radio}
            disabled={disabled}

          />
          <span className={valueOnLabel}>{String(valueOn)}</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/FilterComponents/FilterToggle.js